import { RadioGroup, RadioGroupProps } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  option: {
    minWidth: 180,
  },
})

export type ScheduleSpace = 'building' | 'floor' | 'zone'

interface Props extends Omit<RadioGroupProps<ScheduleSpace>, 'items'> {
  onChange?: (value: ScheduleSpace) => void
}
const ScheduleSpaceRadioGroup = (props: Props) => {
  const { optionStyle, onChange, ...otherProps } = props
  const { t } = useTranslation()
  const items = [
    {
      title: t('Building'),
      value: 'building',
    },
    {
      title: t('Floor'),
      value: 'floor',
    },
    {
      title: t('Zone'),
      value: 'zone',
    },
  ]
  return (
    <RadioGroup
      items={items}
      optionStyle={[styles.option, optionStyle]}
      onSelect={onChange}
      testID="ScheduleSpaceRadioGroup.Container"
      {...otherProps}
    />
  )
}

export default ScheduleSpaceRadioGroup
